document.addEventListener("DOMContentLoaded", function () {
  // Seleccionamos elementos del DOM
  const bubble = document.getElementById("chat-bubble");
  const widget = document.getElementById("chat-widget");
  const closeBtn = document.getElementById("chat-close");
  const sendBtn = document.getElementById("chat-send");
  const inputField = document.getElementById("chat-input");
  const messagesContainer = document.getElementById("chat-messages");

  /*if (isApp()) {
    // Si es una app, ocultamos el chat por defecto
    widget.style.display = "none";
    bubble.style.display = "none";
    return false;
  }*/

  // Variable para mantener el conversation_id entre llamadas
  let conversationId = "";

  // Estado para saber si el chat está abierto
  let isOpen = false;

  /**
   * Añade un mensaje de texto (user o assistant).
   * Usa clases prefijadas z-chat-message y z-chat-user / z-chat-assistant.
   */
  function addMessage(text, sender, isHtml = false) {
    const msgDiv = document.createElement("div");
    msgDiv.classList.add("z-chat-message");
    if (sender === "assistant") {
      msgDiv.classList.add("z-chat-assistant");
    } else {
      msgDiv.classList.add("z-chat-user");
    }
    if (isHtml) {
      msgDiv.innerHTML = text;
    } else {
      msgDiv.textContent = text;
    }
    messagesContainer.appendChild(msgDiv);
    // Scroll automático hacia abajo
    messagesContainer.scrollTop = messagesContainer.scrollHeight;
  }

  /**
   * Renderiza un carrusel de productos en formato minimalista.
   * Envuelve el carousel en un wrapper que captura el scroll-x.
   */
  function addProductCarousel(products) {
    // 1) Creamos el wrapper que controla el scroll-x
    const wrapper = document.createElement("div");
    wrapper.classList.add("z-chat-carousel-wrapper");
    wrapper.style.width = "calc(100% - 10px)"; // Pequeño ajuste para evitar overflow
    wrapper.style.maxWidth = "calc(100% - 10px)";

    // 2) Dentro del wrapper, creamos el carrusel propiamente dicho
    const carousel = document.createElement("div");
    carousel.classList.add("z-chat-product-carousel");

    // 3) Para cada producto, creamos su "item" minimalista
    products.forEach((product) => {
      const item = document.createElement("div");
      item.classList.add("z-chat-product-item");

      // Wrapper de imagen para badge
      const imgWrapper = document.createElement("div");
      imgWrapper.classList.add("z-chat-product-img-wrapper");
      // Añadir clase no-foto-nf solo si la imagen NO es del tipo "NF_X.jpg"

      let regex = /NF\d+/;
      if (!regex.test(product.image.url)) {
        imgWrapper.classList.add("no-foto-nf");
      }

      // Imagen del producto
      const img = document.createElement("img");
      img.src = product.image.url;
      img.alt = product.image.altText || product.title;
      img.loading = "lazy";
      imgWrapper.appendChild(img);

      // Badge de descuento (si aplica)
      if (product.discount && product.discount > 0) {
        const badge = document.createElement("on-sale-badge");
        badge.setAttribute("discount-mode", "percentage");
        badge.classList.add("badge", "badge--on-sale");
        badge.textContent = `-${product.discount} %`;
        imgWrapper.appendChild(badge);
      }
      item.appendChild(imgWrapper);

      // Título del producto
      const title = document.createElement("div");
      title.classList.add("z-chat-product-title");
      title.textContent = product.title;
      item.appendChild(title);

      // Bloque de precios
      const priceContainer = document.createElement("div");
      priceContainer.classList.add("z-chat-product-price-block");

      if (product.discount && product.discount > 0) {
        // Precio oferta (rojo, grande) dentro de <sale-price>
        const oferta = document.createElement("sale-price");
        oferta.classList.add("h6", "text-on-sale");
        oferta.textContent = `${product.price.toFixed(2).replace(".", ",")} €`;
        priceContainer.appendChild(oferta);

        // Fila PVP
        const pvpRow = document.createElement("div");
        pvpRow.classList.add("z-chat-product-pvp-row");

        // PVP tachado (gris) en <compare-at-price>
        const pvp = document.createElement("compare-at-price");
        pvp.classList.add(
          "h6",
          "text-subdued",
          "line-through",
          "z-chat-product-pvp"
        );
        pvp.textContent = `${product.compareAtPrice
          .toFixed(2)
          .replace(".", ",")} €`;
        pvpRow.appendChild(pvp);

        priceContainer.appendChild(pvpRow);
      } else {
        // Solo precio normal en <sale-price> con clases h6 text-subdued
        const normal = document.createElement("sale-price");
        normal.classList.add("h6", "text-subdued");
        normal.textContent = `${product.price.toFixed(2).replace(".", ",")} €`;
        priceContainer.appendChild(normal);
      }
      item.appendChild(priceContainer);

      // Enlace "Ver más"
      const link = document.createElement("a");
      link.classList.add("z-chat-product-link", "button");
      link.href = product.url;
      link.target = "_blank";
      link.rel = "noopener";
      link.textContent = "Ver más";
      item.appendChild(link);

      // Añadimos el item al carrusel
      carousel.appendChild(item);
    });

    // 4) Insertamos el carrusel dentro del wrapper
    wrapper.appendChild(carousel);

    // 5) Finalmente, insertamos el wrapper en #chat-messages
    messagesContainer.appendChild(wrapper);

    // 6) Auto‐scroll vertical hacia abajo para que quede visible
    setTimeout(() => {
      messagesContainer.scrollTop = messagesContainer.scrollHeight;
    }, 100); // Pequeño delay para asegurar que se renderice
  }

  /**
   * Muestra el indicador de escritura
   */
  function showTypingIndicator() {
    // Verificar si ya existe para evitar duplicados
    if (document.querySelector(".z-chat-typing-indicator")) return;

    const typingDiv = document.createElement("div");
    typingDiv.classList.add("z-chat-typing-indicator");

    const typingText = document.createElement("span");
    typingText.classList.add("z-chat-typing-text");
    typingText.textContent = "";

    const dotsContainer = document.createElement("div");
    dotsContainer.classList.add("z-chat-typing-dots");

    // Crear los tres puntos animados
    for (let i = 0; i < 3; i++) {
      const dot = document.createElement("div");
      dot.classList.add("z-chat-typing-dot");
      dotsContainer.appendChild(dot);
    }

    // typingDiv.appendChild(typingText);
    typingDiv.appendChild(dotsContainer);
    messagesContainer.appendChild(typingDiv);

    // Scroll automático hacia abajo
    messagesContainer.scrollTop = messagesContainer.scrollHeight;
  }

  /**
   * Oculta y elimina el indicador de escritura
   */
  function hideTypingIndicator() {
    const typingIndicator = document.querySelector(".z-chat-typing-indicator");
    if (typingIndicator) {
      typingIndicator.remove();
    }
  }

  // ---------------------------------
  // Funciones para abrir y cerrar el chat
  // ---------------------------------
  function openChat() {
    widget.style.display = "flex";
    isOpen = true;
    if (!widget.dataset.initiated) {
      // Detectar idioma
      let lang =
        window.Shopify && Shopify.locale
          ? Shopify.locale
          : navigator.language || navigator.userLanguage || "es";
      lang = lang.toLowerCase();
      let welcomeMsg =
        "¡Hola! 👋 Soy tu asistente de Zacaris. ¿En qué puedo ayudarte hoy?";
      if (lang.startsWith("it")) {
        welcomeMsg =
          "Ciao! 👋 Sono il tuo assistente Zacaris. Come posso aiutarti oggi?";
      } else if (lang.startsWith("fr")) {
        welcomeMsg =
          "Bonjour ! 👋 Je suis votre assistant Zacaris. Comment puis-je vous aider aujourd'hui ?";
      } else if (lang.startsWith("en")) {
        welcomeMsg =
          "Hi! 👋 I'm your Zacaris assistant. How can I help you today?";
      } else if (lang.startsWith("pt")) {
        welcomeMsg =
          "Olá! 👋 Sou o seu assistente Zacaris. Como posso ajudar você hoje?";
      } else if (lang.startsWith("de")) {
        welcomeMsg =
          "Hallo! 👋 Ich bin dein Zacaris-Assistent. Wie kann ich dir heute helfen?";
      } else if (lang.startsWith("es")) {
        welcomeMsg =
          "¡Hola! 👋 Soy tu asistente de Zacaris. ¿En qué puedo ayudarte hoy?";
      }
      addMessage(welcomeMsg, "assistant");
      widget.dataset.initiated = "true";
    }
  }

  function closeChat() {
    widget.style.display = "none";
    isOpen = false;
  }

  // ---------------------------------
  // Event listeners
  // ---------------------------------
  // Alternar chat al hacer clic en la burbuja
  bubble.addEventListener("click", () => {
    if (isOpen) {
      closeChat();
    } else {
      openChat();
      inputField.focus();
    }
  });

  // Cerrar al hacer clic en la “×”
  closeBtn.addEventListener("click", closeChat);

  // Enviar mensaje al hacer clic en enviar
  sendBtn.addEventListener("click", () => {
    const text = inputField.value.trim();
    if (text === "") return;

    // Deshabilitar input y botón
    inputField.disabled = true;
    sendBtn.disabled = true;

    // 1) Mostramos el mensaje del usuario
    addMessage(text, "user");
    inputField.value = "";

    // 2) Mostramos el indicador de escritura
    showTypingIndicator();

    // 3) Preparamos payload para la llamada POST
    // Obtener parámetros dinámicos desde el DOM o variables globales de Shopify
    const payload = {
      message: text,
      site: "zacaris",
      country: window.Shopify && Shopify.country ? Shopify.country : "ES",
      lang: window.Shopify && Shopify.locale ? Shopify.locale : "es",
      conversation_id: conversationId,
    };

    // 4) Hacemos la petición a la API
    fetch("https://api.zacaris.com/zacaris/Chats/initChat", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then((response) => {
        if (!response.ok) throw new Error("Error en la respuesta de la API");
        return response.json();
      })
      .then((data) => {
        // Ocultar el indicador de escritura
        hideTypingIndicator();

        // Actualizamos conversation_id si viene en la respuesta
        if (data.conversation_id) {
          conversationId = data.conversation_id;
        }

        // 5) Si vienen productos, mostramos primer texto y luego el carrusel envuelto
        if (Array.isArray(data.products) && data.products.length > 0) {
          const assistantText =
            data.message || "Estos productos podrían interesarte:";
          addMessage(
            assistantText,
            "assistant",
            /<[a-z][\s\S]*>/i.test(assistantText)
          );
          addProductCarousel(data.products);
        } else {
          // Si no hay productos, mostramos solo el mensaje de texto
          const assistantText =
            data.message || "Lo siento, no hay productos para mostrar.";
          addMessage(
            assistantText,
            "assistant",
            /<[a-z][\s\S]*>/i.test(assistantText)
          );
        }
      })
      .catch((error) => {
        // Ocultar el indicador de escritura también en caso de error
        hideTypingIndicator();
        console.error("Fetch error:", error);
        addMessage("Error al conectar con el asistente.", "assistant");
      })
      .finally(() => {
        // Volver a habilitar input y botón
        inputField.disabled = false;
        sendBtn.disabled = false;
        inputField.focus();
      });
  });

  // Permitir enviar mensaje al presionar Enter
  inputField.addEventListener("keyup", (event) => {
    if (event.key === "Enter") {
      sendBtn.click();
    }
  });

  // Cerrar chat al presionar Esc
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && isOpen) {
      closeChat();
    }
  });
});
